import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { HttpLoaderService } from './http-loader.service';

@Component({
  selector: 'unip-http-loader-overlay',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (loader.visible()) {
      <div class="unip-http-loader" role="status" aria-live="polite" aria-label="Carregando">
        <div class="unip-http-loader__spinner">
          <span></span><span></span><span></span><span></span><span></span>
        </div>
      </div>
    }
  `,
  styles: [`
    .unip-http-loader {
      position: fixed;
      inset: 0;
      background: rgba(16, 66, 127, 0.7);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999;
    }
    .unip-http-loader__spinner {
      display: flex;
      gap: 5px;
    }
    .unip-http-loader__spinner span {
      width: 6px;
      height: 35px;
      background: #fff;
      animation: unip-loader-wave 1.2s infinite ease-in-out;
    }
    .unip-http-loader__spinner span:nth-child(2) { animation-delay: -1.1s; }
    .unip-http-loader__spinner span:nth-child(3) { animation-delay: -1.0s; }
    .unip-http-loader__spinner span:nth-child(4) { animation-delay: -0.9s; }
    .unip-http-loader__spinner span:nth-child(5) { animation-delay: -0.8s; }
    @keyframes unip-loader-wave {
      0%, 40%, 100% { transform: scaleY(0.4); }
      20%           { transform: scaleY(1.0); }
    }
  `]
})
export class HttpLoaderOverlayComponent {
  protected readonly loader = inject(HttpLoaderService);
}
